
























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Table as DataTable, SvgIcon, Button } from "@brankas/web-ui";
import { namespace } from "vuex-class";
import { BankSecretRow, TableColumn } from "@/types";
import { getIntegrationBankFromName } from "@/utils/bank-utils";

// TODO: Support pagination later

const clientModule = namespace("client");

@Component({
  components: {
    DataTable,
    SvgIcon,
    Button,
  },
})
export default class IntegrationList extends Vue {
  @Prop({ type: String, default: null }) clientId!: string | null;

  @clientModule.Action("getClientIntegrations") getClientIntegrations!: (
    clientId: string
  ) => void;
  @clientModule.State("integrations") clientIntegrations!: BankSecretRow[];

  loading = false;

  tableColumns: TableColumn[] = [
    {
      label: "BANK",
      field: "bankCode",
      sortable: true,
      tdClass: "font-sans font-medium",
    },
    {
      label: "LAST UPDATED",
      field: "createdAt",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
    {
      label: "UPDATED BY",
      field: "createdBy",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
  ];

  _getBankName(bankCode: string) {
    const bank = getIntegrationBankFromName(bankCode);

    return bank ? bank.title : "N/A";
  }

  _getBankLogo(bankCode: string) {
    const bank = getIntegrationBankFromName(bankCode);

    return bank && bank.logo;
  }

  @Watch("clientId", { immediate: true })
  watchClientId() {
    this._fetchIntegrations();
  }

  onAddIntegration() {
    this.$router.push({
      name: "client-integration-page",
      params: { clientId: this.clientId as string },
    });
  }

  onRowClick(params: any) {
    const data: BankSecretRow = params.row;

    this.$router.push({
      name: "client-integration-info-page",
      params: {
        clientId: this.clientId as string,
        integrationId: data.id,
      },
    });
  }

  async _fetchIntegrations() {
    if (!this.clientId) return;

    this.loading = true;
    try {
      await this.getClientIntegrations(this.clientId);
    } catch (err) {
      console.error(err.message);
    } finally {
      this.loading = false;
    }
  }
}
